import { render, staticRenderFns } from "./Sidebar-comp.vue?vue&type=template&id=4754086e&"
import script from "./Sidebar-comp.vue?vue&type=script&lang=js&"
export * from "./Sidebar-comp.vue?vue&type=script&lang=js&"
import style0 from "./Sidebar-comp.vue?vue&type=style&index=0&id=4754086e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports